module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-embed": "static-1.26522",
      "conversations-internal-schema": "static-1.12789",
      "head-dlb": "static-1.4938",
      "hs-test-utils": "static-1.7964",
      "hubspot-url-utils": "static-1.4088",
      "HubStyleTokens": "static-2.11409",
      "I18n": "static-7.1610",
      "jasmine-runner": "static-1.6418",
      "quartz": "static-1.6952",
      "react": "static-7.185",
      "sinon": "static-1.9",
      "StyleGuideUI": "static-3.486",
      "webpack-env": "static-1.54",
      "visitor-ui-component-library": "static-1.6087",
      "enviro": "static-4.428",
      "hs-promise-rejection-tracking": "static-1.5489",
      "PortalIdParser": "static-2.388",
      "raven": "static-3.5829",
      "raven-hubspot": "static-1.6136",
      "bend-plugin-trellis-migration": "static-1.3359",
      "moment": "static-3.26",
      "customer-data-email": "static-1.17937",
      "cv-backend-services": "static-1.1551",
      "hub-http": "static-1.6169",
      "immutable": "static-2.79",
      "immutable-less": "static-1.4598",
      "quartz-config": "static-1.730",
      "quartz-core": "static-1.6171",
      "transmute": "static-2.85",
      "HeadJS": "static-2.740",
      "react-dom": "static-7.85",
      "foundations-components": "static-1.7826",
      "framer-motion": "static-1.71",
      "hs-test-utils-bend-plugin": "static-1.3075",
      "msw": "static-1.39",
      "react-redux": "static-7.71",
      "redux": "static-4.16",
      "testing-library": "static-1.151",
      "foundations-theming": "static-1.4365",
      "i18n-data": "static-1.220",
      "metrics-js": "static-1.9592",
      "moment-timezone": "static-5.82",
      "react-utils": "static-2.5300",
      "jasmine": "static-4.4273",
      "csstype": "static-1.50",
      "hoist-non-react-statics": "static-3.9",
      "PatternValidationJS": "static-1.437",
      "react-aria": "static-1.65",
      "styled-components": "static-2.89",
      "UIComponents": "static-3.8356",
      "visitor-ui-component-library-icons": "static-1.5898",
      "bender-build-tools": "static-1.3123",
      "apollo-dlb": "static-3.86",
      "apollo-link-hub-http": "static-2.4597",
      "apollo-stack-hubspot": "static-3.85",
      "classnames": "static-2.10",
      "cssUtils": "static-1.778",
      "customer-data-objects": "static-1.7610",
      "customer-data-ui-utilities": "static-1.9775",
      "data-fetching-client": "static-1.9623",
      "FileManagerCore": "static-1.38958",
      "FileManagerLib": "static-1.39099",
      "foundations-assets": "static-1.4805",
      "graphql": "static-1.81",
      "hs-promise-utils": "static-1.5542",
      "hubspot-apollo-client": "static-1.4825",
      "icons": "static-2.643",
      "react-immutable-proptypes": "static-2.8",
      "react-immutable-render-mixin": "static-1.9",
      "react-input-autosize": "static-2.17",
      "react-select-plus": "static-1.104",
      "react-virtualized": "static-2.98",
      "rpc-client-utils": "static-1.4598",
      "salesImages": "static-1.524",
      "timezone-utils": "static-2.5192",
      "ui-gdpr-components": "static-1.10296",
      "ts-schema": "static-1.4034",
      "hs-locale-management": "static-1.40",
      "hs-lodash": "static-4.45",
      "immer": "static-1.33",
      "dispatcher": "static-1.135",
      "general-store": "static-6.20",
      "hub-http-janus": "static-1.826",
      "hubspotter-http": "static-1.4608",
      "mobile-manifest-mixins": "static-1.514",
      "module-federation": "static-1.22",
      "quartz-auth": "static-1.627",
      "quartz-head": "static-1.617",
      "quartz-i18n": "static-1.627",
      "quartz-routing": "static-1.382",
      "quartz-test": "static-1.627",
      "quartz-tracking": "static-1.331",
      "quick-fetch": "static-1.3873",
      "react-rhumb": "static-1-feature-id-1324-marker-timings.12",
      "ui-fonts": "static-1.671",
      "usage-tracker-container": "static-1.7277",
      "usage-tracker-core": "static-1.7137",
      "bend-plugin-foundations-components": "static-1.4095",
      "floating-ui": "static-1.55",
      "foundations-theming-specialty": "static-1.2081",
      "hs-story-utils": "static-1.9377",
      "react-create-root-preference": "static-1.9",
      "tanstack-table": "static-1.54",
      "trellis-assets": "static-1.1656",
      "ui-images": "static-2.1138",
      "bend-plugin-foundations-theming": "static-1.2848",
      "foundations-theming-base": "static-1.3350",
      "stylex": "static-1.32",
      "HubStyle": "static-2.11717",
      "web-vitals": "static-1.4",
      "sassPrefix": "static-1.155",
      "inbound-db-properties-service-client": "static-1.3797",
      "property-translator": "static-1.5351",
      "react-dnd-compat": "static-1.4568",
      "fast-json-stable-stringify": "static-1.4",
      "ai-components-ui-library": "static-1.8793",
      "audio-components": "static-1.5834",
      "cropperjs": "static-1.10",
      "feedback-loader": "static-1.29197",
      "file-manager-components": "static-1.23459",
      "FileManagerImages": "static-1.36610",
      "foundations-components-legacy": "static-1.851",
      "immerable": "static-1.4102",
      "redux-toolkit": "static-1.7",
      "reselect": "static-2.16",
      "ui-universal-auth": "static-1.8910",
      "urlinator": "static-1.4480",
      "video-components": "static-1.13092",
      "video-data-lib": "static-1.34747",
      "video-embed": "static-1.35581",
      "redux-thunk": "static-2.43",
      "hubspot-apollo-cache": "static-1.284",
      "bend-plugin-chirp-manifest": "static-1.8",
      "chirp-fetch": "static-1.1834",
      "hub-http-shared-msw-handlers": "static-1.9836",
      "hubspotter-http-shared-msw-handlers": "static-1.9834",
      "history": "static-4.47",
      "react-router-dom": "static-5.26",
      "usage-tracker-session-replay": "static-1.4973",
      "react-dnd": "static-5.6",
      "react-dnd-html5-backend": "static-5.6",
      "autolinker": "static-3.11",
      "chatspot-core": "static-1.21022",
      "ContentUtils": "static-1.68199",
      "copilot-toolkit": "static-1.10969",
      "customer-data-objects-ui-components": "static-1.12973",
      "sanitize": "static-1.4421",
      "sanitize-text": "static-1.8092",
      "content-assistance-lib": "static-1.7669",
      "usage-tracker": "static-1.7287",
      "ui-addon-iframeable": "static-1.9001",
      "video-components-external": "static-1.11089",
      "unified-auth-core-lib": "static-1.705",
      "content-icons-ui": "static-1.2211",
      "social-insights-client-types": "static-1.21929",
      "SharedI18nStrings": "static-1.182",
      "outpost": "static-1.4138",
      "amplitude-session-replay-browser": "static-1.59",
      "markdown-it": "static-1.6",
      "cms-field-types": "static-1.4759",
      "integrations-lib": "static-1.15941",
      "underscore": "static-1.8",
      "magpie-lib": "static-1.5526",
      "magpie-types": "static-1.4986",
      "simple-logging-lib": "static-1.2997",
      "atom": "static-1.5020",
      "avatar-components": "static-1.2446",
      "reference-resolvers": "static-1.8118",
      "superstore": "static-1.4715",
      "ui-addon-video-player": "static-1.8647",
      "ui-coaching-tips": "static-1.28389",
      "navigation-messaging": "static-1.7165",
      "content-media-composition-data-lib": "static-1.12063",
      "content-media-compositions": "static-2.16070",
      "idb-keyval": "static-1.43",
      "media-bridge-lib": "static-1.18831",
      "fsm": "static-1.3681",
      "flux-actions": "static-1.330",
      "frontend-preferences-client": "static-1.7876",
      "integrations-error-boundary-lib": "static-1.13356",
      "integrations-tracking-lib": "static-1.5547",
      "laboratory-lib": "static-3.7107",
      "native-integrations-shared-strings": "static-1.7732",
      "redux-observable": "static-1.11",
      "ReduxMessenger": "static-2.10320",
      "rxjs": "static-5.10",
      "ui-addon-i18n": "static-1.11099",
      "ui-shepherd-react": "static-3.10097",
      "unified-auth": "static-1.424",
      "reactive-lib": "static-1.670",
      "growth-onboarding-feedback-components": "static-1.6532",
      "js-cookie": "static-1.18",
      "universal-page-editor-lib": "static-1.2961",
      "foundations-components-test-utils": "static-1.5309",
      "google-sheets-integration-lib": "static-1.73",
      "microsoft-drive-integration-lib": "static-1.185",
      "react-dlb": "static-1.77",
      "crm-record-cards-service-types": "static-1.3567",
      "framework-data-schema-resolvers": "static-1.6827",
      "location-customization-utils-lib": "static-1.9078",
      "batch-promise": "static-1.1499",
      "conditional-properties-service-client": "static-1.3753",
      "crm-pipelines-api-client-types": "static-1.4099",
      "framework-builder-read-service-client": "static-1.3966",
      "framework-data-schema-quick-fetch": "static-1.6732",
      "inbound-db-meta-service-client": "static-1.3547",
      "multi-currency-client-types": "static-1.3648",
      "persist-promise": "static-1.3656"
    },
    "depPathPrefixes": {
      "conversations-embed": "/conversations-embed/static-1.26522",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.12789",
      "head-dlb": "/head-dlb/static-1.4938",
      "hs-test-utils": "/hs-test-utils/static-1.7964",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.4088",
      "HubStyleTokens": "/HubStyleTokens/static-2.11409",
      "I18n": "/I18n/static-7.1610",
      "jasmine-runner": "/jasmine-runner/static-1.6418",
      "quartz": "/quartz/static-1.6952",
      "react": "/react/static-7.185",
      "sinon": "/sinon/static-1.9",
      "StyleGuideUI": "/StyleGuideUI/static-3.486",
      "webpack-env": "/webpack-env/static-1.54",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.6087",
      "enviro": "/enviro/static-4.428",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5489",
      "PortalIdParser": "/PortalIdParser/static-2.388",
      "raven": "/raven/static-3.5829",
      "raven-hubspot": "/raven-hubspot/static-1.6136",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3359",
      "moment": "/moment/static-3.26",
      "customer-data-email": "/customer-data-email/static-1.17937",
      "cv-backend-services": "/cv-backend-services/static-1.1551",
      "hub-http": "/hub-http/static-1.6169",
      "immutable": "/immutable/static-2.79",
      "immutable-less": "/immutable-less/static-1.4598",
      "quartz-config": "/quartz-config/static-1.730",
      "quartz-core": "/quartz-core/static-1.6171",
      "transmute": "/transmute/static-2.85",
      "HeadJS": "/HeadJS/static-2.740",
      "react-dom": "/react-dom/static-7.85",
      "foundations-components": "/foundations-components/static-1.7826",
      "framer-motion": "/framer-motion/static-1.71",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3075",
      "msw": "/msw/static-1.39",
      "react-redux": "/react-redux/static-7.71",
      "redux": "/redux/static-4.16",
      "testing-library": "/testing-library/static-1.151",
      "foundations-theming": "/foundations-theming/static-1.4365",
      "i18n-data": "/i18n-data/static-1.220",
      "metrics-js": "/metrics-js/static-1.9592",
      "moment-timezone": "/moment-timezone/static-5.82",
      "react-utils": "/react-utils/static-2.5300",
      "jasmine": "/jasmine/static-4.4273",
      "csstype": "/csstype/static-1.50",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "react-aria": "/react-aria/static-1.65",
      "styled-components": "/styled-components/static-2.89",
      "UIComponents": "/UIComponents/static-3.8356",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.5898",
      "bender-build-tools": "/bender-build-tools/static-1.3123",
      "apollo-dlb": "/apollo-dlb/static-3.86",
      "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4597",
      "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.85",
      "classnames": "/classnames/static-2.10",
      "cssUtils": "/cssUtils/static-1.778",
      "customer-data-objects": "/customer-data-objects/static-1.7610",
      "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9775",
      "data-fetching-client": "/data-fetching-client/static-1.9623",
      "FileManagerCore": "/FileManagerCore/static-1.38958",
      "FileManagerLib": "/FileManagerLib/static-1.39099",
      "foundations-assets": "/foundations-assets/static-1.4805",
      "graphql": "/graphql/static-1.81",
      "hs-promise-utils": "/hs-promise-utils/static-1.5542",
      "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4825",
      "icons": "/icons/static-2.643",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "react-select-plus": "/react-select-plus/static-1.104",
      "react-virtualized": "/react-virtualized/static-2.98",
      "rpc-client-utils": "/rpc-client-utils/static-1.4598",
      "salesImages": "/salesImages/static-1.524",
      "timezone-utils": "/timezone-utils/static-2.5192",
      "ui-gdpr-components": "/ui-gdpr-components/static-1.10296",
      "ts-schema": "/ts-schema/static-1.4034",
      "hs-locale-management": "/hs-locale-management/static-1.40",
      "hs-lodash": "/hs-lodash/static-4.45",
      "immer": "/immer/static-1.33",
      "dispatcher": "/dispatcher/static-1.135",
      "general-store": "/general-store/static-6.20",
      "hub-http-janus": "/hub-http-janus/static-1.826",
      "hubspotter-http": "/hubspotter-http/static-1.4608",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.514",
      "module-federation": "/module-federation/static-1.22",
      "quartz-auth": "/quartz-auth/static-1.627",
      "quartz-head": "/quartz-head/static-1.617",
      "quartz-i18n": "/quartz-i18n/static-1.627",
      "quartz-routing": "/quartz-routing/static-1.382",
      "quartz-test": "/quartz-test/static-1.627",
      "quartz-tracking": "/quartz-tracking/static-1.331",
      "quick-fetch": "/quick-fetch/static-1.3873",
      "react-rhumb": "/react-rhumb/static-1-feature-id-1324-marker-timings.12",
      "ui-fonts": "/ui-fonts/static-1.671",
      "usage-tracker-container": "/usage-tracker-container/static-1.7277",
      "usage-tracker-core": "/usage-tracker-core/static-1.7137",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4095",
      "floating-ui": "/floating-ui/static-1.55",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2081",
      "hs-story-utils": "/hs-story-utils/static-1.9377",
      "react-create-root-preference": "/react-create-root-preference/static-1.9",
      "tanstack-table": "/tanstack-table/static-1.54",
      "trellis-assets": "/trellis-assets/static-1.1656",
      "ui-images": "/ui-images/static-2.1138",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2848",
      "foundations-theming-base": "/foundations-theming-base/static-1.3350",
      "stylex": "/stylex/static-1.32",
      "HubStyle": "/HubStyle/static-2.11717",
      "web-vitals": "/web-vitals/static-1.4",
      "sassPrefix": "/sassPrefix/static-1.155",
      "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3797",
      "property-translator": "/property-translator/static-1.5351",
      "react-dnd-compat": "/react-dnd-compat/static-1.4568",
      "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
      "ai-components-ui-library": "/ai-components-ui-library/static-1.8793",
      "audio-components": "/audio-components/static-1.5834",
      "cropperjs": "/cropperjs/static-1.10",
      "feedback-loader": "/feedback-loader/static-1.29197",
      "file-manager-components": "/file-manager-components/static-1.23459",
      "FileManagerImages": "/FileManagerImages/static-1.36610",
      "foundations-components-legacy": "/foundations-components-legacy/static-1.851",
      "immerable": "/immerable/static-1.4102",
      "redux-toolkit": "/redux-toolkit/static-1.7",
      "reselect": "/reselect/static-2.16",
      "ui-universal-auth": "/ui-universal-auth/static-1.8910",
      "urlinator": "/urlinator/static-1.4480",
      "video-components": "/video-components/static-1.13092",
      "video-data-lib": "/video-data-lib/static-1.34747",
      "video-embed": "/video-embed/static-1.35581",
      "redux-thunk": "/redux-thunk/static-2.43",
      "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.284",
      "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.8",
      "chirp-fetch": "/chirp-fetch/static-1.1834",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9836",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9834",
      "history": "/history/static-4.47",
      "react-router-dom": "/react-router-dom/static-5.26",
      "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4973",
      "react-dnd": "/react-dnd/static-5.6",
      "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
      "autolinker": "/autolinker/static-3.11",
      "chatspot-core": "/chatspot-core/static-1.21022",
      "ContentUtils": "/ContentUtils/static-1.68199",
      "copilot-toolkit": "/copilot-toolkit/static-1.10969",
      "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12973",
      "sanitize": "/sanitize/static-1.4421",
      "sanitize-text": "/sanitize-text/static-1.8092",
      "content-assistance-lib": "/content-assistance-lib/static-1.7669",
      "usage-tracker": "/usage-tracker/static-1.7287",
      "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9001",
      "video-components-external": "/video-components-external/static-1.11089",
      "unified-auth-core-lib": "/unified-auth-core-lib/static-1.705",
      "content-icons-ui": "/content-icons-ui/static-1.2211",
      "social-insights-client-types": "/social-insights-client-types/static-1.21929",
      "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
      "outpost": "/outpost/static-1.4138",
      "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.59",
      "markdown-it": "/markdown-it/static-1.6",
      "cms-field-types": "/cms-field-types/static-1.4759",
      "integrations-lib": "/integrations-lib/static-1.15941",
      "underscore": "/underscore/static-1.8",
      "magpie-lib": "/magpie-lib/static-1.5526",
      "magpie-types": "/magpie-types/static-1.4986",
      "simple-logging-lib": "/simple-logging-lib/static-1.2997",
      "atom": "/atom/static-1.5020",
      "avatar-components": "/avatar-components/static-1.2446",
      "reference-resolvers": "/reference-resolvers/static-1.8118",
      "superstore": "/superstore/static-1.4715",
      "ui-addon-video-player": "/ui-addon-video-player/static-1.8647",
      "ui-coaching-tips": "/ui-coaching-tips/static-1.28389",
      "navigation-messaging": "/navigation-messaging/static-1.7165",
      "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12063",
      "content-media-compositions": "/content-media-compositions/static-2.16070",
      "idb-keyval": "/idb-keyval/static-1.43",
      "media-bridge-lib": "/media-bridge-lib/static-1.18831",
      "fsm": "/fsm/static-1.3681",
      "flux-actions": "/flux-actions/static-1.330",
      "frontend-preferences-client": "/frontend-preferences-client/static-1.7876",
      "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13356",
      "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5547",
      "laboratory-lib": "/laboratory-lib/static-3.7107",
      "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7732",
      "redux-observable": "/redux-observable/static-1.11",
      "ReduxMessenger": "/ReduxMessenger/static-2.10320",
      "rxjs": "/rxjs/static-5.10",
      "ui-addon-i18n": "/ui-addon-i18n/static-1.11099",
      "ui-shepherd-react": "/ui-shepherd-react/static-3.10097",
      "unified-auth": "/unified-auth/static-1.424",
      "reactive-lib": "/reactive-lib/static-1.670",
      "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6532",
      "js-cookie": "/js-cookie/static-1.18",
      "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2961",
      "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5309",
      "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.73",
      "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.185",
      "react-dlb": "/react-dlb/static-1.77",
      "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3567",
      "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6827",
      "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9078",
      "batch-promise": "/batch-promise/static-1.1499",
      "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3753",
      "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4099",
      "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3966",
      "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6732",
      "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3547",
      "multi-currency-client-types": "/multi-currency-client-types/static-1.3648",
      "persist-promise": "/persist-promise/static-1.3656"
    },
    "bundlingPackage": "conversations-embed",
    "bundlingPackageVersion": "static-1.26522",
    "project": "conversations-embed",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};